import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useMutation } from 'react-query';

import { useEvents } from '../../../hooks';
import {
  Event,
  EventsResult,
  SanitizedEventParams,
  getEvents,
} from '../../../utils/backend-api/events';
import { Spinner } from '../../BaseUI';
import EventCard from '../EventCard';
import styles from './styles.module.css';

const EventList = () => {
  const [pastEvents, setPastEventList] = useState<Event[]>([]);
  const { events, isFetchingMoreEvents } = useEvents();
  const [nextPage, setNextPage] = useState<number | null>(null);

  useEffect(() => {
    if (!isFetchingMoreEvents) {
      setPastEventList(events.pastEvents);
      setNextPage(events.nextPage);
    }
  }, [isFetchingMoreEvents, events?.nextPage, events?.pastEvents]);

  const { mutate: fetchmoreEvents, isLoading: isFetchMoreEvents } = useMutation(
    async (parameters: SanitizedEventParams) => await getEvents(parameters),
    {
      onSuccess: (data: EventsResult) => {
        setPastEventList((prevState) => [...prevState, ...data.pastEvents]);
        setNextPage(data.nextPage);
      },
    }
  );

  return (
    <>
      {isFetchingMoreEvents ? (
        <Spinner />
      ) : (
        <>
          <div className={styles.eventListContainer}>
            {pastEvents.map((event) => (
              <EventCard
                key={event.image}
                image={event.image}
                highlight={event.highlight}
                date={event.date}
                name={event.name}
                location={event.location}
                slug={event.slug}
              />
            ))}
          </div>
          <div className={styles.actionContainer}>
            {isFetchMoreEvents ? (
              <Spinner />
            ) : (
              nextPage &&
              !isFetchMoreEvents && (
                <div>
                  <Button
                    onClick={() => fetchmoreEvents({ page: nextPage })}
                    className="profile-button btn btn-primary"
                  >
                    See more past events
                  </Button>
                </div>
              )
            )}
          </div>
        </>
      )}
    </>
  );
};

export default EventList;
